import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useUserStore } from '@/stores/user/useUserStore';

export default defineNuxtRouteMiddleware(async (to, from) => {
    if (to.meta.auth || to.meta.guest) {
        const userStore = useUserStore();
        await userStore.ready;
        if (!userStore.user && to.meta.auth) {
            return navigateTo('/');
        }
    }
});
